import { useEffect, useRef, useState } from "react";
import axios from "axios";

const DEBOUNCE_MS = 300;

// Inline word picker for linking an AnswerConnector to a dictionary Word -
// same server-side debounced search as students/WordSearchSelect.jsx, but
// rendered as a ~300px flyout attached to the connector text field's "add
// word" button instead of a separate modal overlay, so it reads as part of
// the same add-answer-connector-container card rather than a popup on top
// of it.
export default function WordLinkPickerPanel({ isOpen, onSelect }) {
    const [query, setQuery] = useState("");
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const debounceRef = useRef(null);

    useEffect(() => {
        if (!isOpen) {
            setQuery("");
            setResults([]);
        }
    }, [isOpen]);

    useEffect(() => {
        if (!isOpen) return;
        if (!query.trim()) {
            setResults([]);
            return;
        }
        setLoading(true);
        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
            axios
                .get("/api/words?search=" + encodeURIComponent(query.trim()), { withCredentials: true })
                .then((response) => setResults(Array.isArray(response.data) ? response.data : []))
                .catch(() => setResults([]))
                .finally(() => setLoading(false));
        }, DEBOUNCE_MS);
        return () => {
            if (debounceRef.current) clearTimeout(debounceRef.current);
        };
    }, [query, isOpen]);

    const primaryTranslation = (w) => (w.translations && w.translations.length ? w.translations[0].translation : "");
    const stopMouseDown = (e) => e.stopPropagation();

    return (
        <div className={"connector-word-picker-panel" + (isOpen ? " open" : "")} onMouseDown={stopMouseDown}>
            <div className="connector-word-picker-panel-inner">
                <input
                    className="connector-word-picker-search"
                    type="text"
                    placeholder="Шукати слово..."
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                />
                <div className="connector-word-picker-list">
                    {loading ? <div className="connector-word-picker-empty">Завантаження...</div> : ""}
                    {!loading && !query.trim() ? <div className="connector-word-picker-empty">Введіть текст, щоб знайти слово</div> : ""}
                    {!loading && query.trim() && results.length === 0 ? <div className="connector-word-picker-empty">Нічого не знайдено</div> : ""}
                    {!loading
                        ? results.map((w) => (
                              <div key={w.id} className="connector-word-picker-option" onClick={() => onSelect(w)}>
                                  <span className="connector-word-picker-option-word">{w.word}</span>
                                  {primaryTranslation(w) ? <span className="connector-word-picker-option-translation">{primaryTranslation(w)}</span> : ""}
                              </div>
                          ))
                        : ""}
                </div>
            </div>
        </div>
    );
}
